import { render } from "./SingleShiftModal.vue?vue&type=template&id=1f7383c4"
import script from "./SingleShiftModal.vue?vue&type=script&lang=js"
export * from "./SingleShiftModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__